import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IGetRepresentativeDetailsResponse {
  status?: boolean;
  message?: string;
  data?: {
    id?: string;
    userId?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    gender?: string;
    phoneNumber?: string;
    dateOfBirth?: string;
    email?: string;
    bvn?: string;
    idNumber?: string;
    idType?: string;
    nationality?: string;
    memberType?: string;
    bvnVerificationStatus?: string;
    idVerificationStatus?: string;
    createdAt?: string;
    updatedAt?: string;
    businessMemberId?: string;
    businessId?: string;
    approvedAt?: string;
    isApproved?: boolean;
    created_at?: string;
    updated_at?: string;
  };
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetRepresentativeDetailsResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getRepresentativeDetailsAsync = createAsyncThunk(
  'representativeDetails',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get('/kyb/representative', config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const representativeDetailsGetSlice = createSlice({
  name: 'representativeDetails/get',
  initialState,
  reducers: {
    resetGetRepresentativeDetails: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRepresentativeDetailsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getRepresentativeDetailsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetRepresentativeDetailsResponse;
      })
      .addCase(getRepresentativeDetailsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetRepresentativeDetailsResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetRepresentativeDetails } =
  representativeDetailsGetSlice.actions;

export default representativeDetailsGetSlice.reducer;
